import { render, staticRenderFns } from "./WaitingPlayersNotification.vue?vue&type=template&id=f2b93ff4&scoped=true&"
import script from "./WaitingPlayersNotification.vue?vue&type=script&lang=js&"
export * from "./WaitingPlayersNotification.vue?vue&type=script&lang=js&"
import style0 from "./WaitingPlayersNotification.vue?vue&type=style&index=0&id=f2b93ff4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2b93ff4",
  null
  
)

export default component.exports